import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { BackToTop } from '@components/back-to-top';
import { CoverageLimits } from '@components/shared/coverage-limits';
import { CustomersGet } from '@components/shared/customers-get';
import { FAQ } from '@components/shared/faq';
import { HeroWidget } from '@components/shared/hero-widget';
import { HowItWorks } from '@components/shared/how-it-works';
import { MaintenanceCredit } from '@components/shared/maintenance-credit';

@Component({
  selector: 'hsc-quoting-page',
  imports: [CommonModule, HeroWidget, HowItWorks, CustomersGet, MaintenanceCredit, FAQ, BackToTop, CoverageLimits],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <hsc-hero-widget></hsc-hero-widget>
    <hsc-how-it-works></hsc-how-it-works>
    <hsc-customers-get></hsc-customers-get>
    <hsc-coverage-limits></hsc-coverage-limits>
    <hsc-maintenance-credit></hsc-maintenance-credit>
    <hsc-faq></hsc-faq>
    <hsc-back-to-top></hsc-back-to-top>
  `,
})
export class QuotingPage {}
